'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _FromLabel = require('components/FromLabel/FromLabel');

var _FromLabel2 = _interopRequireDefault(_FromLabel);

var _TextLine = require('components/TextLine/TextLine');

var _TextLine2 = _interopRequireDefault(_TextLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./AlbumItemSystemInfo.scss');

var cn = _bind2.default.bind(styles);

var AlbumItemSystemInfo = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumItemSystemInfo, _PureComponent);

  function AlbumItemSystemInfo() {
    (0, _classCallCheck3.default)(this, AlbumItemSystemInfo);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemSystemInfo.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemSystemInfo)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItemSystemInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album,
          coloredInfo = _props.coloredInfo,
          overflow = _props.overflow;
      var t = this.context.t;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.info, className) },
        _react2.default.createElement(
          _TextLine2.default,
          { overflow: overflow },
          album.sender
        ),
        _react2.default.createElement(
          _TextLine2.default,
          { title: album.labelName, overflow: overflow },
          _react2.default.createElement(_FromLabel2.default, { labelName: album.labelName })
        ),
        _react2.default.createElement(
          _TextLine2.default,
          {
            className: cn({ coloredInfo: coloredInfo }),
            overflow: overflow,
            title: t('Sent date') + ': ' + album.fullSentDate
          },
          t('Sent'),
          ': ',
          album.shortSentDate
        ),
        _react2.default.createElement(
          _TextLine2.default,
          {
            className: styles.expireDate,
            overflow: overflow,
            title: t('Expiry date') + ': ' + album.expiryDateText
          },
          t('Exp'),
          ': ',
          album.expiryDateText
        )
      );
    }
  }]);
  return AlbumItemSystemInfo;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  coloredInfo: _propTypes2.default.bool,
  overflow: _propTypes2.default.bool
}, _class.defaultProps = {
  album: {}
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = AlbumItemSystemInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemSystemInfo/AlbumItemSystemInfo.js
// module id = 812
// module chunks = 1